import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '@/main';
import { ACL } from '@/services/ACL';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      auth: true,
      icon: 'mdi-home-outline',
      title: 'Главная',
    },
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
  },
  {
    path: '/map',
    name: 'TheMap',
    meta: {
      auth: true,
      icon: 'mdi-google-maps',
      title: 'Карта',
    },
    component: () => import(/* webpackChunkName: "TheMap" */ '../views/ComplexesTheMap.vue'),
  },
  {
    path: '/residential-complexes/:id/view',
    name: 'BaseResComplex',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр ЖК',
    },
    props: true,
    component: () => import(/* webpackChunkName: "BaseResComplex" */ '../components/residentComplex/BaseResComplex.vue'),
  },
  {
    path: '/map/:resComById/doorphone/:id',
    name: 'TheMapIndividual',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр',
    },
    props: true,
    component: () => import(/* webpackChunkName: "TheMapIndividual" */ '../components/complexesMap/IndividualTheMap.vue'),
  },
  {
    path: '/map/:resComById/barrier/:id',
    name: 'TheMapIndividualBarrier',
    meta: {
      icon: 'icon-config',
      title: 'Шлагбаум на карте',
    },
    props: true,
    component: () => import(/* webpackChunkName: "TheMapIndividual" */ '../components/complexesMap/IndividualTheMap.vue'),
  },
  {
    path: '/residential-complexes',
    name: 'ResidentialComplexes',
    meta: {
      auth: true,
      icon: 'mdi-home-map-marker',
      title: 'Жилые комплексы',
    },
    component: () => import(/* webpackChunkName: "TheMap" */ '../views/ResidentialComplexes.vue'),
  },
  {
    path: '/areas',
    name: 'Areas',
    meta: {
      auth: true,
      icon: 'mdi-home-city-outline',
      title: 'Районы',
    },
    component: () => import(/* webpackChunkName: "Areas" */ '../views/Areas.vue'),
  },
  {
    path: '/areas/area-description/:id?',
    name: 'AreasAreaDescription',
    meta: {
      icon: 'icon-building',
      title: 'Описание района',
    },
    component: () => import(/* webpackChunkName: "Areas" */ '../components/areas/AreaDescription.vue'),
  },
  {
    path: '/mto-sector/:id',
    name: 'MtoSectorDetail',
    meta: {
      title: 'Участок МТО',
    },
    props: true,
    component: () => import(/* webpackChunkName: "MtoSectorDetail" */ '../views/MtoSectorDetail.vue'),
  },
  {
    path: '/list-cliens',
    name: 'ListClients',
    meta: {
      auth: true,
      icon: 'mdi-account-circle',
      title: 'Список клиентов',
    },
    component: () => import(/* webpackChunkName: "ListClients" */ '../views/ListClients.vue'),
  },
  {
    path: '/abonents/new/:id',
    name: 'NewAbonent',
    meta: {
      icon: 'icon-key',
      title: 'Создание абонента',
    },
    component: () => import(/* webpackChunkName: "Access-keys" */ '../components/client/NewAbonent.vue'),
  },
  {
    path: '/resident-accounts/:id',
    name: 'Resident-accounts-view',
    meta: {
      icon: 'icon-user',
      title: 'Посмотреть данные аккаунта',
    },
    props: true,
    component: () => import(/* webpackChunkName: "ResidentAccountsView" */ '../components/accounts/ViewAccount.vue'),
  },
  {
    path: '/agents',
    name: 'Agents',
    meta: {
      auth: true,
      icon: 'mdi-alert-circle-outline',
      title: 'Агенты',
    },
    component: () => import(/* webpackChunkName: "Agents" */ '../views/Agents.vue'),
  },
  {
    path: '/agents/new',
    name: 'NewAgent',
    meta: {
      icon: 'icon-info',
      title: 'Новый агент',
    },
    component: () => import(/* webpackChunkName: "NewAgent" */ '../components/agents/NewAgent.vue'),
  },
  {
    path: '/agents/edit/:id',
    name: 'EditAgent',
    meta: {
      icon: 'icon-info',
      title: 'Редактирование агента',
    },
    component: () => import(/* webpackChunkName: "EditAgent" */ '../components/agents/EditAgent.vue'),
  },
  {
    path: '/agents/new-type',
    name: 'NewTypeAgent',
    meta: {
      icon: 'icon-info',
      title: 'Новый тип агента',
    },
    component: () => import(/* webpackChunkName: "NewTypeAgent" */ '../components/agents/NewTypeAgent.vue'),
  },
  {
    path: '/management',
    name: 'Management',
    meta: {
      auth: true,
      icon: 'mdi-home-account',
      title: 'Управляющие компании',
    },
    component: () => import(/* webpackChunkName: "Management" */ '../views/Management.vue'),
  },
  {
    path: '/management/new',
    name: 'NewManagementCompany',
    meta: {
      icon: 'icon-config',
      title: 'Создание управляющей компании',
    },
    component: () => import(/* webpackChunkName: "EditManagementCompany" */ '../components/managementCompany/NewManagementCompany.vue'),
  },
  {
    path: '/management/:id/edit',
    name: 'EditManagementCompany',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование управляющей компании',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditManagementCompany" */ '../components/managementCompany/EditManagementCompany.vue'),
  },
  {
    path: '/group/management',
    name: 'GroupManagement',
    meta: {
      auth: true,
      icon: 'mdi-account-multiple',
      title: 'Компании',
    },
    component: () => import(/* webpackChunkName: "Management" */ '../views/GroupManagement.vue'),
  },
  // {
  //   path: '/calls',
  //   name: 'Calls',
  //   meta: {
  //     auth: true,
  //     icon: 'icon-calling',
  //     title: 'Вызовы',
  //   },
  //   component: () => import(/* webpackChunkName: "Calls" */ '../views/Calls.vue'),
  // },
  {
    path: '/access-keys',
    name: 'Access-keys',
    meta: {
      auth: true,
      icon: 'mdi-key',
      title: 'Ключи доступа',
    },
    component: () => import(/* webpackChunkName: "Access-keys" */ '../views/AccessKeys.vue'),
  },
  {
    path: '/access-keys/:id',
    name: 'DetailAccessKey',
    meta: {
      icon: 'icon-config',
      title: 'Ключ',
    },
    props: true,
    component: () => import(/* webpackChunkName: "DetailAccessKey" */ '../components/accessKeys/DetailAccessKey.vue'),
  },
  {
    path: '/access-keys/:id/edit',
    name: 'EditKey',
    meta: {
      icon: 'icon-key',
      title: 'Редактировать ключ',
    },
    props: true,
    component: () => import(/* webpackChunkName: "Access-keys" */ '../components/accessKeys/EditAccessKey.vue'),
  },
  {
    path: '/access-key/new',
    name: 'NewKey',
    meta: {
      icon: 'icon-key',
      title: 'Новый ключ доступа',
    },
    component: () => import(/* webpackChunkName: "Access-key" */ '../components/accessKeys/NewAccessKey.vue'),
  },
  {
    path: '',
    name: 'PACS',
    meta: {
      auth: false,
      icon: 'mdi-doorbell-video',
      title: 'СКУД',
      isLinks: false,
    },
  },
  {
    path: '/doorphones',
    name: 'Doorphone',
    meta: {
      auth: true,
      isPacs: false,
      icon: 'mdi-doorbell-video',
      title: 'Домофоны',
    },
    component: () => import(/* webpackChunkName: "Doorphone" */ '../views/Doorphone.vue'),
  },
  {
    path: '/barriers',
    name: 'Barriers',
    meta: {
      auth: true,
      isPacs: false,
      icon: 'mdi-boom-gate-outline',
      title: 'Шлагбаумы',
    },
    component: () => import(/* webpackChunkName: "Barriers" */ '../views/Barriers.vue'),
  },
  {
    path: '/barrier/new',
    name: 'BaseFormNewBarrier',
    meta: {
      icon: 'icon-config',
      title: 'Добавление Шлагбаума',
    },
    component: () => import(/* webpackChunkName: "BaseFormNewBarrier" */ '../components/barrier/NewBarrier/BaseFormNewBarrier.vue'),
  },
  {
    path: '/barrier/:id/',
    name: 'DetailBarrier',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр Шлагбаума',
      isInfoDevice: true,
      typeDevice: 'B',
    },
    props: true,
    component: () => import(/* webpackChunkName: "DetailBarrier" */ '../components/barrier/DetailBarrier/DetailBarrier.vue'),
  },
  {
    path: '/barrier/:id/edit',
    name: 'EditBarrier',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование Шлагбаума',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditBarrier" */ '../components/barrier/EditBarrier/EditBarrier.vue'),
  },
  {
    path: '/Controllers',
    name: 'Controllers',
    meta: {
      icon: 'mdi-access-point-network',
      title: 'Контроллеры',
    },
    component: () => import(/* webpackChunkName: "Barriers" */ '../views/Controllers.vue'),
  },
  {
    path: '/controller/new',
    name: 'BaseFormNewController',
    meta: {
      icon: 'icon-config',
      title: 'Добавление контроллера',
    },
    component: () => import(/* webpackChunkName: "BaseFormNewBarrier" */ '../components/controller/NewController/BaseFormNewController.vue'),
  },
  {
    path: '/controller/:id/',
    name: 'DetailController',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр Контроллера',
    },
    props: true,
    component: () => import(/* webpackChunkName: "DetailController" */ '../components/controller/DetailController/DetailController.vue'),
  },
  {
    path: '/controller/:id/edit',
    name: 'EditController',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование Контроллера',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditController" */ '../components/controller/EditController/EditController.vue'),
  },
  {
    path: '/gates',
    name: 'Gates',
    meta: {
      auth: true,
      isPacs: false,
      icon: 'mdi-gate-alert',
      title: 'Калитки',
    },
    component: () => import(/* webpackChunkName: "Gates" */ '../views/Gates.vue'),
  },
  {
    path: '/gate/:id/',
    name: 'DetailGate',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр калитки',
      isInfoDevice: true,
      typeDevice: 'G',
    },
    props: true,
    component: () => import(/* webpackChunkName: "DetailGate" */ '../components/gate/DetailGate/BaseDetailGate.vue'),
  },
  {
    path: '/gate/:id/edit',
    name: 'EditGate',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование калитки',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditGate" */ '../components/gate/EditGate/BaseEditGate.vue'),
  },
  {
    path: '/base-gate/new',
    name: 'BaseFormNewGate',
    meta: {
      icon: 'icon-config',
      title: 'Добавление калитки',
    },
    component: () => import(/* webpackChunkName: "BaseFormNewGate" */ '../components/gate/NewGate/BaseFormNewGate.vue'),
  },
  // {
  //   path: '/gate/new',
  //   name: 'NewGateDoorphone',
  //   meta: {
  //     icon: 'icon-config',
  //     title: 'Добавление калитки - домофон',
  //   },
  //   component: () => import(/* webpackChunkName: "NewGateDoorphone" */ '../components/doorphone/NewDoorphone/NewGate.vue'),
  // },
  {
    path: '/doorphone/new',
    name: 'NewDoorphone',
    meta: {
      icon: 'icon-config',
      title: 'Добавление домофона',
    },
    component: () => import(/* webpackChunkName: "NewDoorphone" */ '../components/doorphone/NewDoorphone/NewDoorphone.vue'),
  },
  {
    path: '/doorphones/:id/',
    name: 'DetailDoorphone',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр домофона',
      isInfoDevice: true,
      typeDevice: 'I',
    },
    props: true,
    component: () => import(/* webpackChunkName: "DetailDoorphone" */ '../components/doorphone/DetailDoorphone/DetailDoorphone.vue'),
  },
  {
    path: '/doorphones/:id/edit',
    name: 'EditDoorphone',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование домофона',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditDoorphone" */ '../components/doorphone/EditDoorphone/EditDoorphone.vue'),
  },
  {
    path: '/doorphones/:id/new-key',
    name: 'NewDoorphoneKey',
    meta: {
      icon: 'icon-key',
      title: 'Новый ключ домофона',
    },
    component: () => import(/* webpackChunkName: "DoorphoneKey" */ '../components/doorphone/NewKey.vue'),
  },
  {
    path: '/device',
    name: 'Device',
    meta: {
      auth: true,
      icon: 'mdi-cog-outline',
      title: 'Устройства',
    },
    component: () => import(/* webpackChunkName: "Device" */ '../views/Device.vue'),
  },
  {
    path: '/device/new',
    name: 'NewDevice',
    meta: {
      icon: 'icon-config',
      title: 'Добавление устройства',
    },
    component: () => import(/* webpackChunkName: "NewDevice" */ '../components/device/NewDevice.vue'),
  },
  {
    path: '/device/:id/edit',
    name: 'EditDevice',
    meta: {
      icon: 'icon-config',
      title: 'Редактирование устройства',
    },
    props: true,
    component: () => import(/* webpackChunkName: "EditDevice" */ '../components/device/EditDevice.vue'),
  },
  {
    path: '/mass-function',
    name: 'MassFunction',
    meta: {
      auth: true,
      icon: 'mdi-cog-outline',
      title: 'Массовые функции',
    },
    component: () => import(/* webpackChunkName: "MassFunction" */ '../views/MassFunction.vue'),
  },
  {
    path: '/mass-function/open-door-sound',
    name: 'MassOpenDoorSound',
    meta: {
      title: 'Загрузка на домофоны',
    },
    component: () => import(/* webpackChunkName: "MassOpenDoorSound" */ '../views/MassOpenDoorSound.vue'),
  },
  // {
  //   path: '/analytics-serve',
  //   name: 'AnalyticsServerList',
  //   meta: {
  //     auth: true,
  //     icon: 'mdi-server-security',
  //     title: 'Серверы аналитики',
  //   },
  //   component: () => import(/* webpackChunkName: "AnalyticsServerList" */ '../NewBarrier/analyticsServer/List'),
  // },
  // {
  //   path: '/analytics-serve/:id',
  //   name: 'AnalyticsServerShow',
  //   props: true,
  //   meta: {
  //     icon: 'icon-config',
  //     title: 'Сервер аналитики',
  //   },
  //   component: () => import(/* webpackChunkName: "AnalyticsServerShow" */ '../NewBarrier/analyticsServer/Show'),
  // },
  {
    path: '/admin-function',
    name: 'AdminFunction',
    meta: {
      auth: true,
      icon: 'mdi-account-cog-outline',
      title: 'Администрирование',
    },
    component: () => import('../views/AdminFunction.vue'),
  },
  {
    path: '/reports',
    name: 'Reports',
    meta: {
      auth: true,
      icon: 'mdi-chart-box-outline',
      title: 'Отчёты',
    },
    component: () => import('../views/Reports.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    meta: {
      auth: true,
      icon: 'mdi-account',
      title: 'Пользователи',
    },
    component: () => import('../views/Users.vue'),
  },
  {
    path: '/user/new',
    name: 'NewUser',
    meta: {
      icon: 'icon-user',
      title: 'Новый пользователь',
    },
    component: () => import('../components/users/NewUser.vue'),
  },
  {
    path: '/user/:id/edit',
    name: 'EditUser',
    meta: {
      icon: 'icon-user',
      title: 'Редактирование пользователя',
    },
    props: true,
    component: () => import('../components/users/EditUser.vue'),
  },
  {
    path: '/client/new',
    name: 'NewClient',
    meta: {
      icon: 'icon-config',
      title: 'Добавление клиента',
    },
    component: () => import('../components/client/NewClient.vue'),
  },
  {
    path: '/client/car-number-search',
    name: 'CarNumberSearchDetail',
    meta: {
      icon: 'mdi-car-search',
      title: 'Подробности по гос. номеру',
    },
    component: () => import(/* webpackChunkName: "CarNumberSearchDetail" */ '../views/CarNumberSearchDetail.vue'),
  },
  {
    path: '/client/:id',
    name: 'DetailClient',
    meta: {
      icon: 'icon-config',
      title: 'Просмотр клиента',
    },
    props: true,
    component: () => import('../components/client/DetailClient/DetailClient.vue'),
  },
  {
    path: '/auth/callback',
    name: 'OAuthCallback',
    meta: {
      auth: false,
      title: 'Вход через ЭВО ID',
    },
    component: () => import(/* webpackChunkName: "OAuthCallback" */ '../views/OAuthCallback.vue'),
  },
  {
    path: '/not-found/404',
    name: 'NotFound',
    meta: {
      title: 'Страница не найдена',
    },
    component: () => import(/* webpackChunkName: "NotFound" */ '../components/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === 'OAuthCallback' || to.path === '/auth/callback') {
    return next();
  }

  const roleName = store.getters.roleName;
  if (roleName && ACL.roles[roleName]) {
    const permissions = ACL.roles[roleName].routes;

    if (to.name === 'TheMap' && roleName === 'admin-engineer') {
      if (to.query && to.query.showModal === 'true') return next();
      return next({ name: 'NotFound', params: { path: to.path } });
    }
    return permissions.includes(to.name)
      ? next()
      : next({ name: 'NotFound', params: { path: to.path } });
  }

  return next();
});

export default router;
